import { useState  } from "react";
import { useNavigate } from "react-router-dom";
import { useRePassMutation } from "context/auth/authApiSlice";
import { useForm, Controller  } from "react-hook-form";

import useHelper from "hooks/useHelper";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDInput from "dashboard/components/MDInput";
import MDButton from "dashboard/components/MDButton";
import MDAlert from "dashboard/components/MDAlert";

import { LinearProgress } from "@mui/material";

// Authentication layout components
import CoverLayout from "components/layouts/CoverLayout";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";

function ResetPass() {
  const navigate = useNavigate();
  const  [errorMsg, setErrorMsg] = useState("");
  const { isValidEmail } = useHelper();
  const { register, handleSubmit, control, formState: { errors } } = useForm({
      defaultValues:{
          email:''
  }});
  const [passChange,{isLoading, isSuccess}] = useRePassMutation();

  const onSubmit = async data =>{   
    const {email} = data;
    try{
    /*eslint-disable*/
    const userData = await passChange({email}).unwrap();
    navigate(`/authentication/NewPass/`, {
       state : {email}
    })
    } catch(err) {
      setErrorMsg(`${err.data.error.toString()}`);
    }
  }

  return (
    <CoverLayout coverHeight="50vh"  lg={3.1} rest image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Vous recevrez un e-mail dans 60 secondes maximum
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
        {isLoading && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}
          <MDBox component="form" onSubmit={handleSubmit(onSubmit)} noValidate role="form">
            <MDBox mb={4}>
            <Controller name="email" control={control} 
                    render={({ field: { onChange, value } }) => (
                    <MDInput   onChange={onChange}   value={value} type="email" label="Email" required fullWidth 
                    {...register("email", { required: "a valide email is required.", validate : isValidEmail })}
                    error={Boolean(errors.email)}
                    helperText={errors.email?.message} 
                    variant="standard"
                    />
                    )}
                />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                reset
              </MDButton>
            </MDBox>
            {errorMsg && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
            {(isSuccess && !errorMsg) && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> Your request has been sent, Please check your email </small></MDAlert> }
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default ResetPass;
